import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { Fallback, PageProgress, SwitchWith404 } from '../shared/components';
import IndependentApp from './IndependentApp';
import InsideApp from './InsideApp';
import useAppConfig from './useAppConfig';

export default function MicroApp() {
  const { appConfig } = useAppConfig();

  if (!appConfig) {
    return <PageProgress />;
  }

  return (
    <Suspense fallback={<Fallback />}>
      <SwitchWith404>
        {/* 独立应用，使用乾坤加载 */}
        {appConfig.apps
          .filter((item: any) => item.independent)
          .map((config: any) => {
            return (
              <Route
                key={config.activeRule}
                path={config.activeRule}
                render={() => {
                  return <IndependentApp {...config} />;
                }}
              />
            );
          })}

        {/* 非独立应用，使用内置加载器初始化 */}
        {appConfig.apps
          .filter((item: any) => !item.independent)
          .map((config: any) => {
            return (
              <Route
                key={config.activeRule}
                path={config.activeRule}
                render={() => {
                  return <InsideApp {...config} />;
                }}
              />
            );
          })}
      </SwitchWith404>
    </Suspense>
  );
}
